import { render, staticRenderFns } from "./ZkyCom.vue?vue&type=template&id=0fe66196&scoped=true"
import script from "./ZkyCom.vue?vue&type=script&lang=js"
export * from "./ZkyCom.vue?vue&type=script&lang=js"
import style0 from "./ZkyCom.vue?vue&type=style&index=0&id=0fe66196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe66196",
  null
  
)

export default component.exports